<template>
  <transition
    :enter-active-class="transitionEnterClass"
    :leave-active-class="transitionLeaveClass"
    name="slide"
    mode="out-in"
  >
    <v-container
      grid-list-md
      fluid
      class="pa-2"
    >
      <router-view :key="$route.path" />
    </v-container>
  </transition>
</template>

<script>
import pageTransitionMixin from '@/mixins/page-transition-mixin';

export default {
  name: 'Analytics',
  mixins: [pageTransitionMixin],
  data() {
    return {};
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Analytics' });
  },
  beforeRouteUpdate(to, from, next) {
    this.updatePageTransition(to, from);
    next();
  }
};
</script>